import { render, staticRenderFns } from "./ConsignatariasDialog.vue?vue&type=template&id=f8620ec4&"
import script from "./ConsignatariasDialog.vue?vue&type=script&lang=js&"
export * from "./ConsignatariasDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports